<template>
  <a
    class="d-reviews-count grid-flex grid-middle grid-no-response"
    :disabled="!numReviews"
    @click="triggerClick"
  >
    <span class="grid-item-shrink space-right-1em">
      {{ rating }} star ({{ numReviews }})
    </span>
    <span class="grid-item">
      <DuiSlimProgressBar
        class="color-yellow-grey-bg"
        :value="percentage"
      />
    </span>
  </a>
</template>

<script>
export default {
  props: {
    numReviews: {
      type: Number,
      default: 0,
    },
    percentage: {
      type: Number,
      required: true,
    },
    rating: {
      type: Number,
      required: true,
    },
  },
  methods: {
    triggerClick() {
      if (!this.numReviews) {
        return;
      }

      this.$emit('click');
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@dui-styles/base";

.d-reviews-count {
  color: getColor($black);
  font-weight: normal;

  &[disabled] {
    opacity: $disabled-opacity;
    pointer-events: none;
  }

  &:hover {
    color: getColor($yellow, medium);
  }
}
</style>
